import type { WhiteboardSpec } from "../spec";

// Only the tutor's own (audio-paced) transcript drives the board. Learner speech
// recognition is not shown or matched: the voice model understands learners
// better than transcription does, so the tutor judges spoken answers.

/** Visible choices the tutor might name aloud, per native task. */
export function emphasisTargets(spec: WhiteboardSpec | undefined): string[] {
  if (!spec) return [];
  switch (spec.kind) {
    case "gap_fill":
    case "quick_choice":
      return spec.options;
    case "composed":
      return spec.blocks.flatMap((block) =>
        block.type === "contrast_pair"
          ? block.pairs.flatMap((pair) => [pair.left, pair.right])
          : block.type === "tap_group"
            ? block.options
            : block.type === "translation_choice"
              ? block.options.map((option) => option.text)
              : []
      );
    default:
      return [];
  }
}

/** Index just past the last occurrence of `sequence` in `words`, or -1. */
export function lastSequenceEnd(words: string[], sequence: string[]): number {
  for (let start = words.length - sequence.length; start >= 0; start -= 1) {
    if (sequence.every((token, offset) => words[start + offset] === token))
      return start + sequence.length;
  }
  return -1;
}
